import React from 'react'
import { Container, Row, Col, Card, CardBody, Input } from 'reactstrap'
import DataTable from 'react-data-table-component'
import { Breadcrumbs } from '../../AbstractElements'
import HeaderCard from './Component/HeaderCard'
import { Link } from 'react-router-dom'
import { useLayout } from '../../Hooks/useLayout'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'

const DataManagementGrid = ({
	title,
	subTitle,
	breadcrumbTitle,
	breadcrumbMainTitle,
	columns,
	data,
	loading,
	searchQuery,
	setSearchQuery,
	searchPlaceholder = 'Search...',
	createButtonText = 'Create New',
	createButtonLink,
	createButtonDisabled = false,
	onDelete,
	searchFields = [],
	noDataMessage = 'No data found',
	customHeaderComponent,
	showTable = true,
	additionalActionButton,
	customTableStyles
}) => {
	const layout = useLayout()
	const role = useRoleBasedUrl()

	// Handle search filtering
	const filteredData = data.filter((item) => {
		if (!searchQuery) return true

		return searchFields.some((field) => {
			const value = item[field]
			if (value === null || value === undefined) return false
			return String(value).toLowerCase().includes(searchQuery.toLowerCase())
		})
	})

	// Prepare data for datatable with actions
	const tableData = filteredData.map((item) => ({
		...item,
		onDelete: onDelete ? () => onDelete(item.id) : undefined
	}))

	return (
		<>
			{breadcrumbTitle && breadcrumbMainTitle && <Breadcrumbs parent={breadcrumbTitle} title={title} mainTitle={breadcrumbMainTitle} />}
			<Container fluid={true}>
				<Row>
					<Col sm="12">
						<Card>
							{title && <HeaderCard title={title} subTitle={subTitle} />}
							<CardBody>
								<div className="d-flex justify-content-between align-items-center mb-3">
									<div className="d-flex align-items-center gap-3">
										{customHeaderComponent ? (
											customHeaderComponent
										) : (
											<Input
												type="text"
												placeholder={searchPlaceholder}
												value={searchQuery}
												onChange={(e) => setSearchQuery(e.target.value)}
												style={{ width: '300px' }}
											/>
										)}
									</div>
									<div className="d-flex gap-2">
										{additionalActionButton}
										{createButtonLink && (
											<Link
												to={createButtonLink}
												className={`btn btn-primary ${createButtonDisabled ? 'disabled' : ''}`}
												style={{ pointerEvents: createButtonDisabled ? 'none' : 'auto' }}
											>
												<i className="fa fa-plus me-2"></i>
												{createButtonText}
											</Link>
										)}
									</div>
								</div>

								{showTable && (
									<div className={`table-responsive${customTableStyles ? ' rdt-head-wrap' : ''}`}>
										<DataTable
											columns={columns(layout, role)}
											data={tableData}
											striped={true}
											center={true}
											pagination
											paginationPerPage={10}
											paginationRowsPerPageOptions={[10, 25, 50, 100]}
											progressPending={loading}
											highlightOnHover={true}
											responsive={true}
											noDataComponent={noDataMessage}
											{...(customTableStyles ? { customStyles: customTableStyles } : {})}
										/>
									</div>
								)}
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
		</>
	)
}

export { DataManagementGrid }
